'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'

const TWO_MINUTES = 2 * 60 * 1000

interface ReplayIntegration {
  name: string
  start: () => void
  startBuffering: () => void
  stop: () => Promise<void>
  flush: () => Promise<void>
}

export function SentryReplayControl({
  isEnabled,
}: {
  isEnabled: boolean
}) {
  useEffect(() => {
    if (isEnabled) {
      const client = Sentry.getClient()
      const replay =
        client?.getIntegrationByName<ReplayIntegration>('Replay')

      // flush() converts from buffer mode (set by replaysOnErrorSampleRate)
      // to session mode. Using start() would no-op when buffering is active.
      void replay?.flush()

      // Use startBuffering() instead of stop() to end session replay
      // while preserving error-triggered replays (replaysOnErrorSampleRate)
      const timer = setTimeout(() => {
        replay?.startBuffering()
      }, TWO_MINUTES)

      return () => {
        clearTimeout(timer)
        replay?.startBuffering()
      }
    }
  }, [isEnabled])

  return null
}
